import requestv2 from "~/utils/http-v2";

const notificationApi = {
	gets : async (params) => {
		const url = `v2/notifications`;
		return await requestv2.get(url, {params});
	},
	count : async (params) => {
		const url = `v2/notifications/count`;
		return await requestv2.get(url, {params});
	},
	read : async (params) => {
		const url = `v2/notifications/read`;
		return await requestv2.post(url, params);
	},
	open : async (params) => {
		const url = `v2/notifications/open`;
		return await requestv2.post(url, params);
	},

	message : async (params) => {
		const url = `v2/notifications/message`;
		return await requestv2.get(url, {params});
	},
	messageCheck : async (params) => {
		const url = `v2/notifications/message/count`;
		return await requestv2.get(url, {params});
	},
	messageRead : async (params) => {
		const url = `v2/notifications/message/read`;
		return await requestv2.post(url, params);
	},
	messageOpen : async (params) => {
		const url = `v2/notifications/message/open`;
		return await requestv2.post(url, params);
	},
};

export default notificationApi;